import PhotoFill from './PhotoFill';

export default PhotoFill;
